<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val && this.noShopInfo.indexOf(val.path) == -1) {
          this.getshopInfo()
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      //这边 不会获取 getshopInfo
      noShopInfo: ["/authWelcome", "/addStore", '/alibabaAuth', '/about', '/toLog', '/skip'],
    }
  },
  methods: {
    getshopInfo() {
      if (localStorage.getItem('logintoken_shop') && localStorage.getItem('logintoken_shop') != '') {
        this.$get(this.$api.shopInfo).then(res => {
          if (res.status == 200) {
            if (res.data.tl.private_key_path && res.data.tl.appid && res.data.tl.cusid) {
              const tl = res.data.tl;
              const allFieldsExist = !!(tl.is_open && tl.private_key_path && tl.appid && tl.cusid);
              this.$store.commit('saveAllFieldsExist', allFieldsExist);
            }
            localStorage.setItem('is_open_product_market', res.data.is_open_product_market);
            localStorage.setItem('shopId', res.data.shop_id);
            this.$store.commit('saveShopStatus', res.data.status);
            this.$store.commit('saveShopData', res.data);
          }
        });
      }
    },
  }
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

#particles-js {
  width: 100%;
  height: 100vh;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
}

.ml15 {
  margin-left: 15px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt20 {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue